import styled from 'styled-components'

export const CategoryTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  margin-bottom: ${props => props.theme.spacing.sp8};
`

export const IntegrationsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: ${props => props.theme.spacing.sp16};
`
